import { render, staticRenderFns } from "./achievementExternal.vue?vue&type=template&id=df763cd6&scoped=true"
import script from "./achievementExternal.vue?vue&type=script&lang=js"
export * from "./achievementExternal.vue?vue&type=script&lang=js"
import style0 from "./achievementExternal.vue?vue&type=style&index=0&id=df763cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df763cd6",
  null
  
)

export default component.exports